import { Product } from "../models"

import Vue from "vue"
import { Component, Prop } from "vue-property-decorator"
import _ from "lodash"

@Component({ name: "ProductList" })
export default class extends Vue {
  @Prop()
  products!: Product[]

  @Prop()
  columnCount: number | undefined

  @Prop()
  onProductClick!: (product: Product) => void

  get chunkedProducts() {
    return _.chunk(_.toArray(this.products), this.columnCount || 3)
  }

  onLearnMoreClick(event: Event, product: Product) {
    event.stopPropagation()

    this.onProductClick(product)
  }

  onCardClick(product: Product) {
    this.onProductClick(product)
  }
}
